export const PHONE_DIGITS_LENGTH = 11;

export const SIGN_IN_CODE_LENGTH = 4;

export const HOME_PATH = "/branchesRegister/general";
